var _desc, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBread({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "17px",
    height: "16px",
    viewBox: "0 0 17 16",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "A0AF6989-8EA7-46A4-A322-3645DBE28BF5") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Created with sketchtool.")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Managers",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Assets",
    transform: "translate(-130.000000, -459.000000)",
    stroke: "#0B2730"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M144.704039,465.781637 L144.503676,472.846707 C144.496667,473.484019 143.672542,474.000366 142.6659,474 L134.343113,473.996975 C133.335223,473.996609 132.511171,473.481365 132.502778,472.839991 L132.279844,465.781637 M144.54467,466.06569 C145.749934,465.321146 147.193418,462.644383 144.350763,460.639967 C141.508107,458.635551 138.630074,462.116427 138.503296,461.979925 M132.445226,466.069635 C131.239962,465.325091 129.813174,462.644383 132.655829,460.639967 C135.498484,458.635551 138.503296,461.979925 138.503296,461.979925",
    id: "brood"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBread);
export default __webpack_public_path__ + "static/media/bread.cf6f15b593e04c7f3860c36705ccde5f.svg";
export { ForwardRef as ReactComponent };